import React from 'react';
import Services from './../services/services';
import Payments from './../services/payments';
import Breadcrumb from './../basics/Breadcrumb';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const Card = () => {

  const payments = new Payments();

  const [gateway, setGateway] = useState();

  let handleClick = () => {
    payments.getPayment('59', 'PAYMENT_CARD', 'https://seznam.cz').then((e) => {
      setGateway(e.gw_url);
      console.log(e.gw_url);
    })
  }

  return (
    <div className="container">
      <div className="d-flex flex-column align-items-center my-5 py-5">
          <i className="text-success fs-1 fa-solid fa-circle-check"></i>
          <div className="fs-2">Letenky úspěšně namoupeny</div>
          <div className="">Potvrzení bude zasláno na Váš email</div>
      </div>

      <button onClick={handleClick}>Test</button>


      <form action={gateway} method="post" id="gopay-payment-button">
        <button name="pay" type="submit">Zaplatit</button>
        <script type="text/javascript" src="https://gw.sandbox.gopay.com/gp-gw/js/embed.js"></script>
      </form>

    </div>
  );
}

export default Card;
